import {FunctionComponent} from 'react';
import {RouteComponentProps} from 'react-router-dom';
import {useHistory} from 'react-router-dom';
import envVariable from '../util/envVariable';
import storage from '../util/storage';
import GetDetailAndStoreItUseCase from '../../useCase/Folder/GetDetailAndStoreItUseCase';
import FetchFolderGateway from '../../gateway/Folder/FetchFolderGateway';
import LocalStorageGateway from '../../gateway/Form/LocalStorageGateway';
import FolderAndPageId from '../../domain/Folder/FolderAndPageId';
import Loader from '../component/loader/Loader';

type Params = {
  dossierId?: string
};

const AccessFolder: FunctionComponent<RouteComponentProps<Params>> = ({match}) => {
  const folderId = match?.params?.dossierId
  const history = useHistory()

  if (!folderId) {
    history.push('/dossiers')
    return null
  }

  const getDetailAndStoreItUseCase = new GetDetailAndStoreItUseCase(new FetchFolderGateway(), new LocalStorageGateway(folderId))

  getDetailAndStoreItUseCase.execute(folderId).then((response: FolderAndPageId|null) => {
    if (response !== null) {
      // Keep localStorage writes for DocuSign compatibility
      storage.setFolderId(response.folder.id)
      storage.setFormId(response.folder.form_id, folderId)
      if (response.folder.status?.length) {
        storage.setDossierState(response.folder.status[0], folderId)
      }
      // Navigate using URL from use case (includes folderId)
      history.push(response.url)
    } else {
      window.location.pathname = envVariable('REACT_APP_REDIRECT_URL')
    }
  })
  
  return <Loader/>
}

export default AccessFolder;
